export default __webpack_public_path__ + "static/media/DAIF_UseCase_In.6df82d32.mp4";